import React, { useRef, useEffect, useState } from "react";
// import Navbar from "../../components/Navbar/Navbar";
// import PartnerSection from "../../components/PartnerSection";
import CoupleSection4 from "../../components/CoupleSection4/CoupleSection4";
import RegalHero from "../../components/RegalMuse/hero";
// import VideoSection from "../../components/VideoSection";
// import StorySection4 from "../../components/StorySection4/StorySection4";
// import PortfolioSectionS2 from "../../components/PortfolioSectionS2/PortfolioSectionS2";
// import BrideGrooms2 from "../../components/BrideGrooms2";
// import RsvpSectionS3 from "../../components/RsvpSectionS3/RsvpSectionS3";
import EventSectionS3 from "../../components/EventSection3/EventSection3";
// import BlogSection from "../../components/BlogSection/BlogSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
// import vImg from "../../images/video-img/img-2.jpg";
// import bg from "../../images/rsvp/bg.jpg";
import VenueSection from "../../components/VenueSection/VenueSection";
import InviteeSection from "../../components/InviteeSection/InviteeSection";
import EventSection4 from "../../components/EventSection4/EventSection4";
import QuoteSection from "../../components/QuoteSection/QuoteSection";
import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";
// import useScrollDirection from "../../hooks/useScrollDirection";

const RegalMuse = () => {
  const containerRef = useRef();

  return (
    <div ref={containerRef} className={`fadeInSlow scroll-container`}>
      {/* <Navbar hclass={"wpo-header-style-3"} /> */}
      <RegalHero />
      {/* <PartnerSection /> */}
      <CoupleSection4 />
      <LetterEnvelope />
      <QuoteSection />
      <EventSection4 haveBackground={false} />
      <VenueSection />
      <RsvpSectionS2 />
      <InviteeSection haveBackground={false} />
      {/* <RsvpSectionS3 bg={bg} /> */}
      {/* <BlogSection bgClass={"section-bg"} /> */}
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </div>
  );
};

export default RegalMuse;
